if (!customElements.get('sa-estimated-delivery')) {
  customElements.define(
    'sa-estimated-delivery',
    class SaEstimatedDelivery extends HTMLElement {
      connectedCallback() {
        this.variantSelects = this.closest('variant-selects');
        this.textNode = this.querySelector('[data-sa-estimated-delivery]');
        this.deliveryMap = this.parseMap();
        this.onChange = this.onChange.bind(this);
        this.variantSelects?.addEventListener('change', this.onChange);
        this.update();
      }

      disconnectedCallback() {
        this.variantSelects?.removeEventListener('change', this.onChange);
      }

      parseMap() {
        const script = this.querySelector('[data-sa-delivery-map]');
        try {
          const parsed = JSON.parse(script?.textContent || '{}');
          return parsed && typeof parsed === 'object' ? parsed : {};
        } catch (error) {
          return {};
        }
      }

      onChange() {
        this.update();
      }

      getSelectedShippingValue() {
        const checkedInputs = this.variantSelects?.querySelectorAll('input:checked') || [];
        for (const input of checkedInputs) {
          const optionName = (input.dataset.optionName || '').toLowerCase();
          if (optionName.includes('shipping')) return input.value;
        }
        return this.dataset.shippingValue || '';
      }

      formatDate(days) {
        const deliveryDate = new Date(Date.now() + Number(days) * 86400000);
        return deliveryDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
      }

      update() {
        if (!this.textNode) return;

        const shippingValue = this.getSelectedShippingValue();
        const days = this.deliveryMap[shippingValue];
        const hasDays = days !== undefined && days !== null && String(days).trim() !== '';

        this.hidden = !hasDays;
        this.textNode.hidden = !hasDays;

        if (!hasDays) {
          this.textNode.textContent = '';
          return;
        }

        this.dataset.shippingValue = shippingValue;
        this.textNode.textContent = `* Estimated delivery by ${this.formatDate(days)}.`;
      }
    },
  );
}
